<template>
  <div class="about-croe">
    <div class="container">
      <div class="about-title">美学中心</div>
      <div class="train-box">
        <div class="train-card">
          <img src="https://img.xnxx.mengcreate.com/LJL/about01.jpg" alt="">
          <div class="train-text">
            <p class="p-color">懒精灵设计师联盟</p>
            <!-- <p class="p-color">Artistic CoatingArtist</p> -->
            <p>懒精灵艺术涂料设有材料美学带头人主持的美学中心、设计师联盟，不断探索墙艺美学开发。</p>
          </div>

        </div>
        <div class="train-card">
          <img src="https://img.xnxx.mengcreate.com/LJL/about02.jpg" alt="">
          <div class="train-text">
            <p class="p-color">定制美学产品</p>

            <p>丰富的懒精灵美学库，积累超过96个不同风格的经典美学产品系列，每个系列的色彩搭配多达24套，满足个性化美学需求。美学中心每年发布新的行业美学趋势，与创新中心推出年度新品，在艺术涂料行业前沿不断探索。</p>
          </div>
        </div>
        <div class="train-card">
          <img src="https://img.xnxx.mengcreate.com/LJL/about03.jpg" alt="">
          <div class="train-text">
            <p class="p-color">VR设计中心</p>
            <p>懒精灵VR软件实时360实景预览，轻松实现墙艺装修美学方案。<br>懒精灵美学库+懒精灵美学库联合出品，引领艺术墙艺行业发展。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang='less'>
.about-croe {
  height: 750px;
  width: 100%;
  background: #e5eeed;
  display: flex;
  align-items: center;
  .container {
    .about-title {
      display: inline-block;
      font-weight: 500;
      padding: 0.2rem;
      border-bottom: 1px #74b828 solid;
      margin-bottom: 2rem;
      color: #74b828;
    }
    .train-box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .train-card {
        background: #fff;
        width: 386px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        img {
          width: 100%;
        }
        .train-text {
          padding: 1rem 1.5rem 0;
          .p-color {
            color: #23886c;
            font-weight: 500;
            font-size: 1.5rem;
            line-height: 1rem;
          }
          p {
            line-height: 2rem;
            font-size: 17px;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 786px) {
  .about-croe {
    position: relative;
    height: auto;
    .container {
      max-width: 786px;
      width: 100%;
      padding: 20px;
      .train-box {
        flex-direction: column;
        .train-card {
          width: 100%;
          margin-bottom: 20px;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>